import MyStartups from '@/views/ecosystem/myStartups/MyStartups.vue'
import Account from "@/views/ecosystem/settings/Account.vue";
import Greeting from "@/views/ecosystem/settings/Greeting";
import Opportunities from "@/views/ecosystem/Opportunities.vue";
import Invite from "@/views/ecosystem/Invite.vue";
import EcosystemHome from "@/views/ecosystem/EcosystemHome.vue";
import Opportunity from "@/views/opportunities/Opportunity.vue";

export default [
    {
        path: '/my-startups',
        component: MyStartups,
        meta: {
            access: ['ecosystem']
        }
    },
    {
        path: '/settings/account',
        component: Account,
        meta: {
            access: ['ecosystem']
        }
    },
    {
        path: '/settings/greeting',
        component: Greeting,
        meta: {
            access: ['ecosystem']
        }
    },
    {
        path: '/opportunities',
        component: Opportunities,
        meta: {
            access: ['ecosystem']
        }
    },
    {
        path: '/opportunities/:opportunityId',
        meta: {
            title: 'Opportunities',
            access: ['ecosystem'],
        },
        component: Opportunity
    },
    {
        path: '/ecosystems-invite/:hash',
        component: Invite,
        meta: {
            guest: true,
            access: ['ecosystem']
        }
    },
    {
        path: '/ecosystem-home',
        component: EcosystemHome,
    },
]
